export enum TIMING_TYPE {
    WEEKS = 'weeks',
    DAYS = 'days',
    MONTHS = 'months'
}
